<p class="form-error animate fadeIn">
  {{ formErrorMessage }}
</p>
